import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import DDos from '@/components/DDos.vue';
import Error from '@/components/Error.vue';
import Loader from '@/components/Loader.vue';
import ReLogin from '@/components/ReLogin.vue';
import Success from '@/components/Success/index.vue';
import Chat from '@/widgets/chat/ui/Chat.vue';
import '@ifr/form-questionnaire/dist/form-questionnaire.css';
import { computed } from 'vue';
import store from '@/store';
import LandscapeWarning from '@/components/layout/LandscapeWarning.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

_useCssVars((_vm, _setup) => ({
  "121d6ee4": (_setup.colorPrimary),
  "07ac036a": (_setup.colorError),
  "5fbce6fd": (_setup.colorRequired),
  "94d4be36": (_setup.colorSuccess),
  "6721e563": (_setup.colorStepperCard),
  "eab149e4": (_setup.verticalIndentation),
  "1a443a40": (_setup.horizontalIndentation)
}))

const theme = computed(() => store.getters.theme);

const colorPrimary = computed(() => theme.value.primary);
const colorError = computed(() => theme.value.error);
const colorRequired = computed(() => theme.value.requiredColor);
const colorSuccess = computed(() => theme.value.success);
const colorStepperCard = computed(() => theme.value.fieldStepperColor);

const verticalIndentation = computed(() => {
  return `${store.getters.verticalIndentation}px`;
});

const horizontalIndentation = computed(() => {
  return `${store.getters.horizontalIndentation}px`;
});

return { __sfc: true,theme, colorPrimary, colorError, colorRequired, colorSuccess, colorStepperCard, verticalIndentation, horizontalIndentation, DDos, Error, Loader, ReLogin, Success, Chat, LandscapeWarning }
}

})